// Accessibility guardrail: pick readable foreground for a given background color.
function hexToRgb(hex) {
  let h = (hex || "").replace("#", "");
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  if (h.length !== 6) return { r: 15, g: 23, b: 42 };
  return {
    r: parseInt(h.slice(0, 2), 16),
    g: parseInt(h.slice(2, 4), 16),
    b: parseInt(h.slice(4, 6), 16),
  };
}

function luminance({ r, g, b }) {
  const a = [r, g, b].map((v) => {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
}

export function contrastRatio(hex1, hex2) {
  const l1 = luminance(hexToRgb(hex1));
  const l2 = luminance(hexToRgb(hex2));
  const lighter = Math.max(l1, l2);
  const darker = Math.min(l1, l2);
  return (lighter + 0.05) / (darker + 0.05);
}

// Returns a WCAG-safe foreground (white or near-black) for a background.
export function readableForeground(bgHex) {
  const whiteRatio = contrastRatio(bgHex, "#FFFFFF");
  const darkRatio = contrastRatio(bgHex, "#0F172A");
  return whiteRatio >= darkRatio ? "#FFFFFF" : "#0F172A";
}

export function isLowContrast(bgHex) {
  return contrastRatio(bgHex, readableForeground(bgHex)) < 4.5;
}
